import * as React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { distanceDropdown } from "./DistanceFilter.module.scss";

export const DistanceDropdown: React.FC<{ children: React.ReactNode }> = (
  props
) => {
  return <Dropdown className={distanceDropdown}>{props.children}</Dropdown>;
};
